import { useProfessionalData } from '~/modules/professional/hook/use-professional-data';
import { useTracker } from '@archipro-website/tracker';

export const usePhoneTracking = () => {
    const professionalData = useProfessionalData();
    const tracker = useTracker();

    // format the phone number to remove spaces
    const phone = professionalData?.professional?.PhoneTracking
        ? professionalData.professional.PhoneTracking.replace(/ /g, '')
        : null;

    // this returns professional.PhoneTracking as they were saved in BM
    const phoneLabel = professionalData?.professional?.PhoneTracking ?? null;

    const handlePhoneClick = () => {
        if (phone) {
            tracker.log(`PhoneSubmit`, {
                url: new URL(window.location.href),
                label: phone,
            });

            // calls the number
            window.location.href = `tel:${phone}`;
        }
    };

    return {
        enabled: !!phone,
        phone,
        phoneLabel,
        handlePhoneClick,
    };
};
